/* eslint-disable prettier/prettier */
// src/pages/ChiSiamo.js
import React, { useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  Button,
  Image,
  VStack,
  HStack,
  SimpleGrid,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import AboutUsImage from '../images/about-us-3.jpg';
import adriano from '../images/adry_590d2abe8e.jpg';
import dario from '../images/dario_aed1493bcc.jpg';
import federico from '../images/fede_2fa5c046c2.jpg';
import alberto from '../images/alby_560x560_f85c7aa1f8.jpg';
import filippo from '../images/filippo.jpeg';
import albertoStoriano from '../images/alberto-storiano.jpeg';
import matteoRiggi from '../images/tasso.png';
import animatoriBg from '../images/animatori.jpg';
import nerdsBg from '../images/nerds.jpg';
import logoCil from '../images/logo.png';

// Stili CSS per la flip card
const flipCardStyles = `
.flip-card {
  background-color: transparent;
  width: 300px;
  height: 400px;
  perspective: 1000px;
}
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}
.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.flip-card-front {
  background-size: cover;
  background-position: center;
  background-color: #3b235a;
}
.flip-card-back {
  background-size: cover;
  background-position: center;
  transform: rotateY(180deg);
  background-color:rgb(35, 65, 90);
}
`;

/* ====================================================
   Componente per l'animazione con Floating Words
   (implementato con Vanilla JavaScript all'interno di React)
   ==================================================== */
const ScrollingWordsSection = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const lyric =
      'Creatività libertà gioco inclusione comunità educazione arte manualità magia strategia divertimento socialità innovazione collaborazione fantasia partecipazione crescita esperienza apprendimento coinvolgimento passione esplorazione avventura espressione talento amicizia condivisione sviluppo scoperta ispirazione interazione immaginazione creatività ludodidattica storytelling narrativa improvvisazione sperimentazione emozione connessione entusiasmo scoperta empowerment curiosità progettazione empatia intuizione originalità evoluzione comunicazione aggregazione supporto sfida opportunità motivazione empowerment ascolto rispetto trasformazione speranza fiducia sogno relazione energia dinamismo accoglienza guida scoperta espressione sensibilità riflessione cultura apprendimento speranza libertà manualità incontro evoluzione confronto crescita personale socializzazione stimolo competenza sostegno intrattenimento coinvolgimento scoperta ispirazione ingegno creatività autenticità espressione capacità visione interazione relazione connessione cooperazione esplorazione analisi condivisione partecipazione fiducia realizzazione accessibilità approfondimento creazione organizzazione progettazione dinamismo attivazione condivisione esperienza trasformazione originalità entusiasmo creatività manualità fiducia equilibrio gioco di ruolo logica pensiero critico ragionamento sfida collaborazione gioco da tavolo avventura esplorazione';

    const words = {};
    const wordsAttr = [];

    // Funzione per analizzare la stringa e contare la frequenza di ogni parola
    function stringHandle(str) {
      const splitStr = str.split(' ');
      const wordArray = [];
      const wordCount = [];
      for (let i = 0; i < splitStr.length; i += 1) {
        let exists = false;
        for (let j = 0; j < wordArray.length; j += 1) {
          if (splitStr[i] === wordArray[j]) {
            wordCount[j] += 1;
            exists = true;
            break;
          }
        }
        if (!exists) {
          wordArray.push(splitStr[i]);
          wordCount.push(1);
        }
      }
      for (let k = 0; k < wordArray.length; k += 1) {
        words[wordArray[k]] = wordCount[k];
      }
      return words;
    }

    // Esegui l'analisi
    stringHandle(lyric);

    // Imposta dimensioni del canvas
    const canvas = canvasRef.current;
    canvas.width = window.innerWidth;
    canvas.height = 400;

    if (canvas.getContext) {
      const ctx = canvas.getContext('2d');
      const w = canvas.width;
      const h = canvas.height;

      // Crea gli oggetti "Word"
      const createWord = (key) => {
        return {
          text: key,
          x: Math.random() * w,
          y: Math.random() * h,
          font: `${words[key] * 10}px arial`,
          speed: words[key],
        };
      };

      Object.keys(words).forEach((key) => {
        wordsAttr.push(createWord(key));
      });

      // Funzione per muovere le parole
      const move = () => {
        for (let i = 0; i < wordsAttr.length; i += 1) {
          if (wordsAttr[i].x > w) {
            wordsAttr[i].x = -wordsAttr[i].width;
            wordsAttr[i].y = Math.random() * h;
          } else {
            wordsAttr[i].x += wordsAttr[i].speed;
          }
        }
      };

      // Funzione per disegnare le parole
      const animation = () => {
        for (let i = 0; i < wordsAttr.length; i += 2) {
          ctx.font = wordsAttr[i].font;
          ctx.fillText(wordsAttr[i].text, wordsAttr[i].x, wordsAttr[i].y);
          wordsAttr[i].width = ctx.measureText(wordsAttr[i].text).width;
        }
        move();
      };

      // Loop di animazione
      const intervalId = setInterval(() => {
        // Pulisci il canvas senza riempire con alcun colore
        ctx.clearRect(0, 0, w, h);

        // Imposta colore del testo
        ctx.fillStyle = '#ffffff';
        ctx.strokeStyle = '#ffffff';

        animation();
      }, 40);

      // Cleanup
      return () => {
        clearInterval(intervalId);
      };
    }
    return undefined;
  }, []);

  return (
    <Box
      // Rimuovi o sostituisci eventuali sfondi solidi/gradient
      bg="transparent"
      width="100%"
      py={10}
    >
      {/* Canvas con background trasparente */}
      <Box maxW="100%" mx="auto" bg="transparent" overflow="hidden">
        <canvas
          ref={canvasRef}
          id="c"
          style={{
            display: 'block',
            background: 'transparent',
            maxWidth: '100%',
          }}
        />
      </Box>
    </Box>
  );
};

/* ====================================================
   Componente ChiSiamo
   ==================================================== */
const ChiSiamo = () => {
  // Dati fittizi per la sezione "Le Persone di CIL"
  const persone = [
    {
      id: 1,
      nome: 'Dario Calì',
      ruolo: 'Presidente',
      immagine: dario,
    },
    {
      id: 2,
      nome: 'Federico Donà',
      ruolo: 'Vicepresidente',
      immagine: federico,
    },
    {
      id: 3,
      nome: 'Adriano Calì',
      ruolo: 'Tesoriere',
      immagine: adriano,
    },
    {
      id: 4,
      nome: 'Filippo Donà',
      ruolo: 'Segretario',
      immagine: filippo,
    },
    {
      id: 5,
      nome: 'Alberto Saccardo',
      ruolo: 'Segretario',
      immagine: alberto,
    },
    {
      id: 6,
      nome: 'Matteo Riggi',
      ruolo: 'Consigliere',
      immagine: matteoRiggi,
    },
    {
      id: 7,
      nome: 'Alberto Storiano',
      ruolo: 'Consigliere',
      immagine: albertoStoriano,
    },
    {
      id: 8,
      nome: 'Eleonora Bechis',
      ruolo: 'Consigliere',
      immagine: AboutUsImage,
    },
    {
      id: 9,
      nome: 'Ludovico Bechis',
      ruolo: 'Consigliere',
      immagine: AboutUsImage,
    },
    {
      id: 10,
      nome: 'Francesca Romanini',
      ruolo: 'Consigliere',
      immagine: AboutUsImage,
    },
  ];

  const imagesCIL = [
    require('../images/ce-2025-3.jpg'),
    require('../images/about-us.jpg'),
    require('../images/sede-1.png'),
  ];

  const [slideIndex, setSlideIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % imagesCIL.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box overflow="hidden" bg="#36393f" color="white">
      {/* HERO SECTION (stesso stile di Network e Bazar: full width, overlay, contenuto container.xl) */}
      <Box
        position="relative"
        minHeight="320px"
        display="flex"
        alignItems="center"
        overflow="hidden"
      >
        <Box
          position="absolute"
          inset={0}
          backgroundImage={`url(${AboutUsImage})`}
          backgroundPosition="center"
          backgroundSize="cover"
        />
        <Box
          position="absolute"
          inset={0}
          bgGradient="linear(to-b, rgba(15, 23, 42, 0.75) 0%, rgba(15, 23, 42, 0.5) 40%, rgba(15, 23, 42, 0.7) 100%)"
        />
        <Container
          maxW="container.xl"
          position="relative"
          zIndex={1}
          py={{ base: 10, md: 15 }}
          px={5}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <VStack spacing={4} textAlign="center">
            <Heading
              as="h1"
              color="white"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight="800"
              letterSpacing="-0.03em"
              textShadow="0 1px 3px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3)"
            >
              Chi Siamo
            </Heading>
            <Text
              color="white"
              fontSize={{ base: 'md', md: 'lg' }}
              opacity={0.95}
              textShadow="0 1px 2px rgba(0,0,0,0.5)"
            >
              Siamo CIL - Creatività in libertà
            </Text>
            <HStack spacing={3} flexWrap="wrap" justify="center">
              <Button
                as={Link}
                to="/attivita"
                bg="#facc15"
                color="#0f172a"
                size="md"
                fontWeight="600"
                borderRadius="12px"
                boxShadow="0 2px 8px rgba(0,0,0,0.25)"
                _hover={{ bg: '#fde047', color: '#0f172a' }}
                transition="all 0.2s ease"
              >
                Le nostre attività
              </Button>
              <Button
                as={Link}
                to="/contattaci"
                variant="outline"
                borderWidth="2px"
                borderColor="rgba(255,255,255,0.9)"
                color="white"
                size="md"
                fontWeight="600"
                borderRadius="12px"
                bg="transparent"
                _hover={{
                  borderColor: 'white',
                  bg: 'rgba(255,255,255,0.15)',
                  color: 'white',
                }}
                transition="all 0.2s ease"
              >
                Contattaci
              </Button>
            </HStack>
          </VStack>
        </Container>
      </Box>
      {/* SEZIONE: Siamo CIL */}
      <Container maxW="container.xl" py={16} px={{ base: 4, md: 8 }}>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align="center"
          justify="space-between"
          gap={10}
        >
          {/* TESTO */}
          <Box
            flex="1"
            bg="#2f3136"
            borderRadius="20px"
            p={8}
            shadow="xl"
            border="1px solid"
            borderColor="gray.600"
          >
            <Heading as="h2" size="xl" mb={4} color="white">
              Siamo CIL
            </Heading>
            <Text fontSize="lg" color="gray.300" mb={4}>
              CIL – Creatività in Libertà è un&apos;associazione culturale ed
              educativa nata per dare spazio al gioco, alla creatività e alla
              crescita personale.
            </Text>
            <Text fontSize="md" color="gray.400">
              Crediamo nella forza dell&apos;immaginazione, nella bellezza della
              partecipazione e nell&apos;importanza di costruire esperienze
              condivise. Le nostre attività si rivolgono a tutte le età, con
              l&apos;obiettivo di rendere ogni incontro un momento
              significativo, inclusivo e stimolante.
            </Text>
          </Box>

          {/* SLIDESHOW */}
          <Box
            flex="1"
            position="relative"
            boxSize={{ base: '100%', md: '300px' }}
            aspectRatio="1 / 1"
            overflow="hidden"
            borderRadius="xl"
            shadow="lg"
          >
            {imagesCIL.map((img, idx) => (
              <Image
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                src={img}
                alt={`Slide ${idx + 1}`}
                objectFit="cover"
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                opacity={slideIndex === idx ? 1 : 0}
                transition="opacity 1s ease-in-out"
              />
            ))}
          </Box>
        </Flex>
      </Container>

      <style>{flipCardStyles}</style>
      <Box
        bg="#2f3136"
        borderRadius="20px"
        px={{ base: 4, md: 8 }}
        py={{ base: 10, md: 10 }}
        mt={8}
        mb={8}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.xl">
          {/* TITOLO E DESCRIZIONE */}
          <Box textAlign="center" mb={12}>
            <Image
              src={logoCil}
              alt="Logo CIL"
              maxW="130px" // limita la larghezza
              height="auto"
              mx="auto"
              mb={4}
            />
            <Heading as="h2" size="xl" color="white" mb={4}>
              Due anime, una visione
            </Heading>
            <Text fontSize="lg" color="gray.300" maxW="3xl" mx="auto">
              CIL nasce dall&apos;incontro tra educatori esperti e creativi
              appassionati. Insieme costruiamo un ponte tra gioco, educazione e
              immaginazione.
            </Text>
          </Box>

          {/* CONTENUTO RESPONSIVE */}
          <Flex
            direction={{ base: 'column', md: 'row' }}
            align="stretch"
            justify="space-between"
            gap={6}
          >
            {/* ANIMATORI */}
            <Box
              flex="1"
              bg="#36393f"
              borderRadius="20px"
              p={6}
              shadow="xl"
              textAlign="center"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Heading as="h3" size="md" mb={2} color="#ffcc00">
                Animatori & Educatori
              </Heading>
              <Text color="gray.300">
                Gli animatori rappresentano il cuore pulsante delle attività di
                CIL. Con anni di esperienza sul campo in centri estivi,
                laboratori scolastici e attività extrascolastiche, sono figure
                capaci di creare ambienti sicuri, stimolanti e inclusivi. Il
                loro approccio è fondato sull’educazione attiva, l’ascolto
                empatico e la valorizzazione di ogni bambino o ragazzo.
                Attraverso il gioco, la narrazione, la cooperazione e
                l’espressività, gli animatori accompagnano i partecipanti in
                percorsi di crescita personale, relazionale e creativa. In ogni
                attività, mettono al centro la relazione umana e la fiducia
                reciproca, rendendo ogni incontro un’occasione unica per
                imparare e divertirsi insieme.
              </Text>
            </Box>

            {/* FLIP CARD CENTRALE */}
            <Box
              flex="1"
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={{ base: 8, md: 0 }}
            >
              <Box className="flip-card" maxW="300px">
                <Box className="flip-card-inner">
                  <Box
                    className="flip-card-front"
                    style={{
                      backgroundImage: `url(${animatoriBg})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  >
                    <Box bg="blackAlpha.700" p={4} borderRadius="md">
                      <Heading as="h4" size="md" mb={2}>
                        ANIMATORI
                      </Heading>
                      <Text fontSize="sm" color="white">
                        Un gruppo con più di 10 anni di esperienza educativa,
                        tra centri estivi e laboratori creativi.
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    className="flip-card-back"
                    style={{
                      backgroundImage: `url(${nerdsBg})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  >
                    <Box bg="blackAlpha.700" p={4} borderRadius="md">
                      <Heading as="h4" size="md" mb={2}>
                        CREATIVI
                      </Heading>
                      <Text fontSize="sm" color="white">
                        Appassionati di giochi da tavolo, Magic, tech e
                        narrazioni: la fantasia al servizio dell’inclusione.
                      </Text>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* CREATIVI */}
            <Box
              flex="1"
              bg="#36393f"
              borderRadius="20px"
              p={6}
              shadow="xl"
              textAlign="center"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Heading as="h3" size="md" mb={2} color="#ffcc00">
                Creativi
              </Heading>
              <Text color="gray.300">
                I creativi digitali sono l’anima visionaria e immaginativa di
                CIL. Portano con sé un bagaglio fatto di passioni, linguaggi e
                strumenti innovativi: dai giochi da tavolo ai videogiochi, dal
                mondo di Magic: The Gathering alle narrazioni fantasy, fino alla
                cultura geek e alle tecnologie interattive. La loro presenza
                trasforma le attività in esperienze coinvolgenti, dove
                l’immaginazione è un ponte tra mondi e generazioni. Credono nel
                valore educativo del gioco strategico, della condivisione e
                dell’esplorazione creativa. Il loro contributo permette a CIL di
                essere uno spazio dove le idee prendono forma, i sogni si
                progettano e l’entusiasmo diventa contagioso.
              </Text>
            </Box>
          </Flex>
        </Container>
      </Box>

      <Box
        bg="#2f3136"
        borderRadius="20px"
        px={{ base: 4, md: 8 }}
        py={{ base: 10, md: 10 }}
        mt={8}
        mb={8}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.xl" position="relative" zIndex={1}>
          <Heading
            as="h2"
            size="xl"
            textAlign="center"
            mb={16}
            color="white"
            fontWeight="bold"
          >
            Cosa Facciamo
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            {/* MISSION */}
            <Box
              bg="#36393f"
              backdropFilter="blur(10px)"
              borderRadius="20px"
              p={8}
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-5px)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Box fontSize="3xl" mb={4} color="#ffcc00">
                🎯
              </Box>
              <Heading as="h3" size="md" mb={3} color="white">
                Mission
              </Heading>
              <Text color="gray.300" fontSize="md">
                Promuoviamo la creatività come chiave per crescere, imparare e
                sentirsi parte di una comunità viva, inclusiva e aperta al
                cambiamento.
              </Text>
            </Box>

            {/* VISION */}
            <Box
              bg="#36393f"
              backdropFilter="blur(10px)"
              borderRadius="20px"
              p={8}
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-5px)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Box fontSize="3xl" mb={4} color="#ffcc00">
                🌈
              </Box>
              <Heading as="h3" size="md" mb={3} color="white">
                Vision
              </Heading>
              <Text color="gray.300" fontSize="md">
                Immaginiamo un mondo in cui ognuno può esplorare le proprie
                passioni, condividere idee e costruire insieme nuovi orizzonti
                culturali e sociali.
              </Text>
            </Box>

            {/* CODICE ETICO */}
            <Box
              bg="#36393f"
              backdropFilter="blur(10px)"
              borderRadius="20px"
              p={8}
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-5px)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Box fontSize="3xl" mb={4} color="#ffcc00">
                🤝
              </Box>
              <Heading as="h3" size="md" mb={3} color="white">
                Codice Etico
              </Heading>
              <Text color="gray.300" fontSize="md">
                Rispetto, equità, ascolto e inclusione. Questi sono i principi
                che guidano ogni nostro progetto e ogni relazione che
                costruiamo.
              </Text>
            </Box>
          </SimpleGrid>
        </Container>
      </Box>

      <Box
        bg="#2f3136"
        borderRadius="20px"
        px={{ base: 4, md: 8 }}
        py={{ base: 10, md: 10 }}
        mt={8}
        mb={8}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.xl">
          {/* TITOLO SEZIONE */}
          <Box textAlign="center" mb={12}>
            <Heading as="h2" size="xl" color="#ffcc00" mb={4}>
              Membri del direttivo
            </Heading>
          </Box>

          {/* DIRETTIVO */}
          <SimpleGrid
            columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
            spacing={6}
            mb={16}
          >
            {persone.map((persona) => (
              <Box
                key={persona.id}
                position="relative"
                overflow="hidden"
                borderRadius="20px"
                shadow="xl"
                border="1px solid"
                borderColor="gray.600"
                transition="all 0.3s"
                _hover={{
                  transform: 'scale(1.03)',
                  borderColor: '#ffcc00',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                }}
                bg="#36393f"
              >
                <Box width="100%" aspectRatio="1" overflow="hidden">
                  <Image
                    src={persona.immagine}
                    alt={persona.nome}
                    objectFit="cover"
                    width="100%"
                    height="100%"
                  />
                </Box>
                <Box p={4}>
                  <Heading as="h3" size="sm" color="white">
                    {persona.nome}
                  </Heading>
                  <Text fontSize="sm" color="gray.300">
                    {persona.ruolo}
                  </Text>
                </Box>
              </Box>
            ))}
          </SimpleGrid>

          {/* DOCUMENTI */}
          <VStack spacing={6}>
            <Heading as="h3" size="lg" color="white" textAlign="center">
              📄 Documenti Ufficiali
            </Heading>

            <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={6} mt={4}>
              {/* BOX 1 - Atto Costitutivo */}
              <Box
                bg="#36393f"
                p={6}
                borderRadius="20px"
                shadow="xl"
                border="1px solid"
                borderColor="gray.600"
                transition="all 0.3s ease"
                _hover={{
                  transform: 'scale(1.03)',
                  shadow: '2xl',
                  borderColor: '#ffcc00',
                }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                textAlign="center"
              >
                <Text fontSize="4xl" mb={2}>
                  📜
                </Text>
                <Heading as="h3" size="sm" mb={2} color="white">
                  Atto Costitutivo
                </Heading>
                <Button
                  as="a"
                  href="https://www.cilassociazione.it/uploads/Atto_costitutivo_DEF_d552e29cab.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  bg="#ffcc00"
                  color="black"
                  size="sm"
                  mt={2}
                  borderRadius="12px"
                  fontWeight="600"
                  _hover={{
                    bg: '#e6b800',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(255, 204, 0, 0.3)',
                  }}
                  transition="all 0.3s ease"
                >
                  Scarica PDF
                </Button>
              </Box>

              {/* BOX 2 - Statuto */}
              <Box
                bg="#36393f"
                p={6}
                borderRadius="20px"
                shadow="xl"
                border="1px solid"
                borderColor="gray.600"
                transition="all 0.3s ease"
                _hover={{
                  transform: 'scale(1.03)',
                  shadow: '2xl',
                  borderColor: '#ffcc00',
                }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                textAlign="center"
              >
                <Text fontSize="4xl" mb={2}>
                  📘
                </Text>
                <Heading as="h3" size="sm" mb={2} color="white">
                  Statuto
                </Heading>
                <Button
                  as="a"
                  href="https://www.cilassociazione.it/uploads/statuto_707777f8f7.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  bg="#ffcc00"
                  color="black"
                  size="sm"
                  mt={2}
                  borderRadius="12px"
                  fontWeight="600"
                  _hover={{
                    bg: '#e6b800',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(255, 204, 0, 0.3)',
                  }}
                  transition="all 0.3s ease"
                >
                  Scarica PDF
                </Button>
              </Box>
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* SEZIONE: ANIMAZIONE CON FLOATING WORDS */}
      <ScrollingWordsSection />

      {/* CALL TO ACTION */}
      <Box
        bg="#2f3136"
        borderRadius="20px"
        px={{ base: 4, md: 0 }}
        py={{ base: 10, md: 10 }}
        mt={8}
        mb={8}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.lg" textAlign="center">
          <Heading as="h2" size="xl" color="white" mb={4}>
            Vuoi far parte della nostra famiglia?
          </Heading>
          <Text color="gray.300" mb={6}>
            Scopri come unirti a noi e contribuire attivamente alla crescita
            della comunità.
          </Text>
          <Button
            as={Link}
            to="/tesseramento"
            size="lg"
            bg="#ffcc00"
            color="black"
            borderRadius="12px"
            fontWeight="600"
            rightIcon={<ExternalLinkIcon />}
            _hover={{
              bg: '#e6b800',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(255, 204, 0, 0.3)',
            }}
            transition="all 0.3s ease"
          >
            Iscriviti Ora
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default ChiSiamo;
